// eslint-disable-next-line
import { ApiConnector, GET } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/models', true);
    return {
        HomeworkList: async data => await API(GET, '/homework_new', false, data).call(false),
        PromoGroupsAttendance: async () => await API(GET, '/promo-groups/attendance', false).call(false),
        QuizzesStatistic: async () => await API(GET, '/quizzes/statistic', false).call(false),
        QuizzesStatisticTeacher: async () => await API(GET, '/quizzes/statistic/teacher', false).call(false),
        QuizzesStatisticSingle: async () => await API(GET, '/quizzes/statistic/single', false).call(false),
        getStatisticsChest: async () => await API(GET, '/game/statistic/chest', false).call(false),
        getNewsAdmin: async data => await API(GET, '/news/super-boss', false).call(false),
        getNewsBoss: async data => await API(GET, '/news/boss', false).call(false),
        getNewsUser: async data => await API(GET, '/news/teacher-franch', false).call(false),
        QuizzesBossList: async () => await API(GET, '/quizzes/list', false).call(false),
        GetVillageSettings: async () => await API(GET, '/settings/village', false).call(false),
        getGroupHistoryHw: async () => await API(GET, '/homeworks/history', false).call(),
        getGroupHistoryHwUsers: async () => await API(GET, '/homeworks/history/users', false).call(),
        getGroupHistoryHwDate: async () => await API(GET, '/homeworks/history/date', false).call(),
        getGroupHistoryHwSettings: async () => await API(GET, '/homeworks/history/single', false).call(),
        getOlympiadChampions: async () => await API(GET, '/olympiad/champions/count', false).call(),
        getOlympiadChampionsForPeriod: async () => await API(GET, '/olympiad/teacher/stat', false).call(),
        GetQuestStatistics: async () => await API(GET, '/quests/stats-by-teacher', false).call(false),
        GetQuestStatisticsByUserId: async () => await API(GET, '/quests/stats-by-user-id', false).call(false),
        GetHomeworkCyclesStats: async () => await API(GET, '/student/stats', false).call(false),
        GetBookAssignmentHistory: async () => await API(GET, '/book/history', false).call(false),
    };
})();
